// Import model
import { StartContactAddNoteRequest } from '../models/StartContactAddNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAddNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAddNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAddNoteRequest instance
   */
  static deserialize(json: string): StartContactAddNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAddNoteRequest instance
   */
  static fromObject(obj: any): StartContactAddNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAddNoteRequest');
    }


    const instance: StartContactAddNoteRequest = {
      content: obj['Content'] as string | undefined,
      name: obj['Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAddNoteRequest instances
   */
  static deserializeArray(json: string): StartContactAddNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAddNoteRequest instance to a JSON string
   */
  static serialize(instance: StartContactAddNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAddNoteRequest instance to a plain object
   */
  static toObject(instance: StartContactAddNoteRequest): any {
    return {
      'Content': instance.content,
      'Name': instance.name,
    };
  }

  /**
   * Serializes an array of StartContactAddNoteRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAddNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
